/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DismountContainerEntry } from '../../models/dismount-container-entry';

export interface DismountContainer$Params {
  workCenterId: number;
      body: DismountContainerEntry
}

export function dismountContainer(http: HttpClient, rootUrl: string, params: DismountContainer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, dismountContainer.PATH, 'post');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

dismountContainer.PATH = '/api/v1/Material/{workCenterId}/Dismount';
